import { Link } from "react-router-dom";
import { Instagram, Phone, MessageSquareText, Music, Facebook } from "lucide-react";
import {
    BRAND,
    PHONE_DISPLAY,
    TEL_HREF,
    SMS_HREF,
    INSTAGRAM_URL,
    INSTAGRAM_HANDLE,
    TIKTOK_URL,
    TIKTOK_HANDLE,
    FACEBOOK_URL,
    SERVICE_AREA_LONG,
    LOGO_URL,
} from "@/lib/site";
import { useSiteText } from "@/lib/siteConfig";
import { EditableText } from "@/lib/editMode";

export default function Footer() {
    const brand = useSiteText("business.brand", BRAND);
    const phone = useSiteText("business.phone_display", PHONE_DISPLAY);
    const area = useSiteText("business.service_area_long", SERVICE_AREA_LONG);
    const insta = useSiteText("business.instagram_url", INSTAGRAM_URL);
    const tiktok = useSiteText("business.tiktok_url", TIKTOK_URL);
    const fb = useSiteText("business.facebook_url", FACEBOOK_URL);
    const tagline = useSiteText("footer.tagline", "Mobile mechanic & performance services. I come to your driveway —");
    const copyright = useSiteText("footer.copyright_suffix", "All rights reserved.");
    const bottomLine = useSiteText("footer.bottom_line", "Mobile mechanic · Hampton Roads, Virginia");
    return (
        <footer
            className="border-t border-white/10 bg-black pt-14 pb-8"
            data-testid="site-footer"
        >
            <div className="lbp-container grid gap-10 md:grid-cols-3">
                <div>
                    <div className="flex items-center gap-2.5">
                        <img src={LOGO_URL} alt={brand} className="h-10 w-10 object-contain" />
                        <span className="font-display font-black uppercase tracking-tight text-white">
                            {brand}
                        </span>
                    </div>
                    <p className="mt-4 text-zinc-400 text-sm leading-relaxed max-w-sm">
                        <EditableText path="footer.tagline" defaultValue={tagline} as="span" multiline />
                        {" "}{area}.
                    </p>
                </div>

                <div>
                    <h4 className="font-display font-bold uppercase tracking-wider text-white text-sm">
                        Get A Quote
                    </h4>
                    <div className="mt-4 flex flex-col gap-3">
                        <a href={SMS_HREF} data-testid="footer-text-link" className="inline-flex items-center gap-2 text-zinc-200 hover:text-red-500 transition-colors text-sm">
                            <MessageSquareText className="w-4 h-4" /> Text {phone}
                        </a>
                        <a href={TEL_HREF} data-testid="footer-call-link" className="inline-flex items-center gap-2 text-zinc-200 hover:text-red-500 transition-colors text-sm">
                            <Phone className="w-4 h-4" /> Call {phone}
                        </a>
                        <a href={insta} target="_blank" rel="noreferrer" data-testid="footer-instagram-link" className="inline-flex items-center gap-2 text-zinc-200 hover:text-red-500 transition-colors text-sm">
                            <Instagram className="w-4 h-4" />@{INSTAGRAM_HANDLE}
                        </a>
                        <a href={tiktok} target="_blank" rel="noreferrer" data-testid="footer-tiktok-link" className="inline-flex items-center gap-2 text-zinc-200 hover:text-red-500 transition-colors text-sm">
                            <Music className="w-4 h-4" />@{TIKTOK_HANDLE} <span className="text-zinc-500">· TikTok</span>
                        </a>
                        <a href={fb} target="_blank" rel="noreferrer" data-testid="footer-facebook-link" className="inline-flex items-center gap-2 text-zinc-200 hover:text-red-500 transition-colors text-sm">
                            <Facebook className="w-4 h-4" /> Facebook
                        </a>
                    </div>
                </div>

                <div>
                    <h4 className="font-display font-bold uppercase tracking-wider text-white text-sm">
                        Navigate
                    </h4>
                    <div className="mt-4 grid grid-cols-2 gap-2 text-sm">
                        <Link to="/services" className="text-zinc-400 hover:text-white">Services</Link>
                        <Link to="/quotes" className="text-zinc-400 hover:text-white">Pricing</Link>
                        <Link to="/gallery" className="text-zinc-400 hover:text-white">Work</Link>
                        <Link to="/articles" className="text-zinc-400 hover:text-white">Articles</Link>
                        <Link to="/refer" className="text-zinc-400 hover:text-white">Refer & Earn</Link>
                        <Link to="/my-rev-cash" className="text-zinc-400 hover:text-white">My Rev Cash</Link>
                        <Link to="/feedback" className="text-zinc-400 hover:text-white">Feedback</Link>
                        <Link to="/about" className="text-zinc-400 hover:text-white">About</Link>
                        <Link to="/contact" className="text-zinc-400 hover:text-white">Contact</Link>
                    </div>
                </div>
            </div>

            <div className="lbp-container mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-zinc-500">
                <span>© {new Date().getFullYear()} {brand}. {copyright}</span>
                <span>{bottomLine}</span>
            </div>
        </footer>
    );
}
